import React, { useEffect } from 'react';
import Contact from '../components/Contact'

import data_analytics_banner from '../assets/data_analytics_banner.jpg'
import data_analytics from '../assets/data_analytics.webp'

const DataAnalyticAndConsulting = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      {/* Hero Section */}
      <div className='mt-20 relative'>
        <div className='relative mt-[6rem]'>
          <img
            className='w-full h-[40rem] object-cover blur-[3px]'
            src= {data_analytics_banner}
            alt='Data and Analytics at Jyotinay Analytics'
          />
          <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
            <p className='text-white text-3xl md:text-5xl font-bold'>
              Data and Analytics at Jyotinay Analytics
            </p>
            <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              At Jyoinay Analytics, we specialize in transforming raw data into meaningful insights that drive informed decision-making. Our data analytics and consulting services help businesses uncover hidden patterns, forecast trends, and optimize operations. From building custom dashboards to offering strategic guidance, we empower organizations to harness the full potential of their data for sustainable growth and innovation.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='container mx-auto mt-12 px-4'>
        <div className='max-w-3xl mx-auto text-left'>
          <p className='text-base md:text-lg leading-relaxed'>
            At Jyoinay Analytics, we go beyond just analyzing data — we turn it into your most powerful asset.
            Our Data Analytics and Consulting services are designed to help businesses of all sizes unlock deep,
            actionable insights from their data. Whether you're looking to improve operational efficiency,
            identify new revenue streams, enhance customer experiences, or make smarter strategic decisions,
            we provide end-to-end solutions tailored to your specific needs.
          </p>

          <img
            className='w-full md:w-[30rem] h-[15rem] object-cover mt-8 rounded-lg shadow-md mx-auto'
            src={data_analytics}
            alt='Analytics Team Working'
          />

          {/* Why Section */}
          <div className='mt-12'>
            <h2 className='text-xl md:text-2xl font-semibold mb-4'>
              Why does your business need Jyoinay Analytics?
            </h2>

            <p className='mb-4 text-base md:text-lg leading-relaxed'>
              In today’s fast-paced, data-driven world, making decisions based on guesswork is no longer enough.
              Businesses that thrive are those that can interpret data accurately and use it to stay ahead of
              market trends, understand customer behavior, and optimize internal processes.
              That’s where Jyoinay Analytics comes in — offering clarity through customized data strategies.
            </p>

            <p className='mb-6 text-base md:text-lg leading-relaxed'>
              Whether you’re overwhelmed with disorganized data or lacking the insights to scale, our consulting
              services are designed to meet you where you are and take you where you need to go.
              With a combination of industry expertise, cutting-edge tools, and a results-driven approach,
              we help you turn complexity into opportunity.
            </p>

            <ul className='list-disc ml-6 space-y-2 text-base md:text-lg'>
              <li>Unlock hidden insights and trends with advanced analytics</li>
              <li>Improve business efficiency through data-driven decision making</li>
              <li>Access expert guidance on modernizing your data infrastructure</li>
              <li>Gain a competitive edge with predictive and prescriptive models</li>
              <li>Tailored dashboards and KPIs that align with your business goals</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Contact Form */}
      <Contact />
    </div>
  )
}

export default DataAnalyticAndConsulting